/** 制作年代の絞り込み関連の定数値 */
export const DECADE = 10;
export const OLDEST_OPTION_INDEX = 6;
